import React from "react";
import Modal from "react-modal";
import "./DynamicModal.css";

Modal.setAppElement("#root");

const DynamicModal = ({
    isOpen,
    onRequestClose,
    title,
    mainContent,
    footerContent,
    customWidth = "75vw",
    customHeight = "85vh",
    customZIndex = 1000,
    centered = false,
    hideHeader = false,
    contentPadding = "1rem",
    bodyOverflowY = "auto",
}) => (
    <Modal
        isOpen={isOpen}
        onRequestClose={onRequestClose}
        className="dynamic-modal-content"
        overlayClassName="dynamic-modal-overlay"
        style={{
            content: {
                width: "100%",
                maxWidth: customWidth,
                height: "auto",
                maxHeight: customHeight,
            },
            overlay: {
                zIndex: customZIndex,
            },
        }}
    >
        {!hideHeader && title && (
            <div className="dynamic-modal-header">
                <h2 className="dynamic-modal-title">{title}</h2>

                <button
                    onClick={onRequestClose}
                    className="dynamic-modal-close"
                    aria-label="Close modal"
                    type="button"
                >
                    &times;
                </button>
            </div>
        )}

        <div
            className="dynamic-modal-body"
            style={{
                padding: contentPadding,
                display: centered ? "flex" : "block",
                alignItems: centered ? "center" : "unset",
                justifyContent: centered ? "center" : "unset",
                textAlign: centered ? "center" : "left",
                overflowY: bodyOverflowY,
            }}
        >
            {mainContent}
        </div>

        {footerContent && (
            <div className="dynamic-modal-footer">
                {footerContent}
            </div>
        )}
    </Modal>
);

export default DynamicModal;